import type { ComponentProps } from 'react'
import CbamReportLiabilityLegacyLayout from './components/CbamReportLiabilityLegacyLayout'
import ImportedGoodsSection from './components/ImportedGoodsSection'

type Props = {
  legacyLayout: ComponentProps<typeof CbamReportLiabilityLegacyLayout>
  importedGoods: ComponentProps<typeof ImportedGoodsSection>
}

export default function CbamReportDetailsLegacyView({ legacyLayout, importedGoods }: Props) {
  return (
    <>
      <CbamReportLiabilityLegacyLayout {...legacyLayout} />
      <ImportedGoodsSection {...importedGoods} />
    </>
  )
}
